/**
 * Vector geometry for the Lentic ripple mark, on a 48×48 canvas.
 * Shared by the decorative watermark and the favicon so they cannot drift.
 */
const C = 24

function pt(r: number, deg: number): [number, number] {
  const rad = (deg * Math.PI) / 180
  return [C + r * Math.cos(rad), C + r * Math.sin(rad)]
}

function arc(r: number, a0: number, a1: number): string {
  const [x0, y0] = pt(r, a0)
  const [x1, y1] = pt(r, a1)
  const large = a1 - a0 > 180 ? 1 : 0
  return `M ${x0.toFixed(2)} ${y0.toFixed(2)} A ${r} ${r} 0 ${large} 1 ${x1.toFixed(2)} ${y1.toFixed(2)}`
}

/** Four concentric ripples, each broken by an opening that rotates outward. */
export const RIPPLE_PATHS: string[] = [
  arc(21, -38, 292),
  arc(15, -14, 268),
  arc(15, 292, 334),
  arc(10.3, 4, 240),
  arc(10.3, 264, 318),
  arc(5.3, 26, 205),
]

export const RIPPLE_DOT = { cx: C, cy: C, r: 2.2 }

/** Standalone SVG markup, for use as a favicon data URI. */
export function rippleSvg(color = '#12564f', strokeWidth = 3.2): string {
  const paths = RIPPLE_PATHS.map(
    (d) =>
      `<path d="${d}" stroke="${color}" stroke-width="${strokeWidth}" stroke-linecap="round"/>`,
  ).join('')

  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">${paths}<circle cx="${RIPPLE_DOT.cx}" cy="${RIPPLE_DOT.cy}" r="${RIPPLE_DOT.r}" fill="${color}"/></svg>`
}
